// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2DUYp","header":"PatientBlock_header__51dg2","label":"PatientBlock_label__u0LQ4","option":"PatientBlock_option__2jq0k"};